import ObjectMessagingModal from './Messages/ObjectMessagingModal';

export default ObjectMessagingModal;
